module.exports = __webpack_public_path__ + "img/5.e810f639.jpg";